<template>
  <b-modal
    no-close-on-backdrop
    header-bg-variant="orange"
    header-text-variant="light"
    centered
    size="xl"
    v-model="open"
    :title="`Vincular produtos com parceiro ${namePartner}`"
    :busy="loading"
    :hide-footer="true"
  >
    <b-row class="mt-2">
      <b-col cols="12" class="mt-3">
        <label>Buscar produto</label>
      </b-col>
      <b-col cols="9">
        <input 
          type="text"
          class="form-control" 
          v-model="searchName" 
          @keyup.enter="search()"
          placeholder="Nome produto, cód. barras ou marca..."
        >
      </b-col>
      <b-col cols="">
        <b-button
          variant="success"
          @click="search()"
        >Pesquisar</b-button>
        <b-button
        class="ml-4"
          variant="warning"
          @click="clean()"
        >Limpar</b-button>
      </b-col>
      
      <b-col cols="12" class="mt-5">
        <b-table
          striped
          outlined
          hover
          responsive
          :fields="table.headers"
          :items="table.records"
          :busy="loading"
          empty-text="Nenhum produto encontrado"
        >
        <template #cell(action)="data">
          <b-button 
            v-if="!productExist(data.item.productId)"
            @click="showPercentageModal(data.item)"
            variant="success"
            data-toggle="tooltip" data-placement="top" title="Vincular produto ao parceiro"
          >
            <i class="fas fa-plus"></i>
          </b-button>
          
          <b-button 
            v-else-if="!isIdPartner(data.item.productId)"
            variant="warning"
            data-toggle="tooltip" data-placement="top" title="Produto vinculado a outro parceiro"
            disabled
          >
            <i class="fas fa-ban"></i>
          </b-button>

          <div v-else>
            <b-button
              @click="deleteProductPartner(data.item.productId)"
              variant="danger"
              data-toggle="tooltip" data-placement="top" title="Desvincular produto do parceiro"
            >
              <i class="fas fa-trash"></i>
            </b-button>
            <b-button
            class="ml-3"
              @click="showPercentageModal(data.item, true)"
              variant="outline-primary"
              data-toggle="tooltip" data-placement="top" title="Alterar porcentagem da margem"
            >
              <i class="fas fa-edit"></i>
            </b-button>
          </div>
        </template>

        <template #cell(photo)="data">
          <img
            :src="linkFotos(data.item.origem) + data.item.photo"
            :alt="data.item.product"
            style="width: 50px;"
          />
        </template>

        <template #cell(priceSalesFormat1)="data">
          <span>{{ formatNumber(data.item.priceSalesFormat1) }}</span>
        </template>

        <template #cell(cost_price)="data">
          <span>{{ formatNumber(data.item.cost_price) }}</span>
        </template>

        <template #cell(tax_rate)="data">
          <span>{{ data.item.tax_rate }} %</span>
        </template>
        </b-table>
      </b-col>
      <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
      ></b-pagination>
    </b-col>
    </b-row>
    <b-row class="d-flex justify-content-end">
      <b-button
        class="mr-3"
        @click="closeModal()"
        variant="danger"
      >
      Fechar
    </b-button>
    </b-row>
    <percentage-partner-modal 
      ref="percentagePartnerModal"
      @save="saveOrUpdate($event)"
    />
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import makeToast from '@/mixins/makeToast';
import UserTypes from '@/enums/UserTypes';
import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import PercentagePartnerModal from '@/components/partner/PercentagePartnerModal.vue';

export default {
  components: { PercentagePartnerModal },
  name: 'modalProductPartner',
  mixins: [makeToast],
  emits: ['closeProductPartnerModal'],

  data() {
    return {
      loading: false,
      idPartner: null,
      idShopkeeper: null,
      namePartner: '',
      searchName:'',
      open: false,
      productsPartners:[],
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 1,
      },
      table:{
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
          key: 'action',
          label: 'Ação',
          },
          {
            key: 'photo',
            label: 'Imagem',
          },
          {
            key: 'product',
            label: 'Produto',
          },
          {
            key:'cost_price',
            label: 'Custo'
          },
          {
            key:'priceSalesFormat1',
            label: 'Venda'
          },
          {
            key:'tax_rate',
            label: 'Taxa'
          },
          {
            key: 'codbar',
            label: 'Cod. barras',
          },
          {
            key: 'marca',
            label: 'Marca',
          },
        ],
        records:[]
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  watch: {
    'pagination.currentPage': function () {
      this.get();
    },
  },
  methods: {
    ...mapActions('shopkeeper', ['getSelectedProducts']),

    toggleOpen({ idPartner = null, idShopkeeper = null, name = "" }) {
      this.open = !this.open;
      this.idPartner = idPartner;
      this.idShopkeeper = idShopkeeper;
      this.namePartner = name;
      this.clean();
    },

    productExist(id){
      if(this.productsPartners.length == 0) return
      
      const result = this.productsPartners.map((item) => {
        if(item.product_id == id) {
          return true;
        }
      });

      return result.includes(true);
    },
    isIdPartner(id){
      if(this.productsPartners.length == 0) return
      
      const result = this.productsPartners.map((item) => {
        if(item.product_id == id && item.partner_user_id == this.idPartner) return true;
      });

      return result.includes(true);
    },
    search() {
      this.table.records = [];
      this.pagination.currentPage = 1;
      this.get();
    },
    clean() {
      this.table.records = [];
      this.pagination.currentPage = 1;
      this.searchName = '';
      this.get();
    },
    get() {
      if (this.loading) return;
      this.loading = true;
      this.$store.dispatch('startLoader');

      this.getSelectedProducts({
        userId: this.userTypeId(),
        productName: this.searchName,
        currentPage: this.pagination.currentPage,
        familyId: 0
      })
      .then((response) => {
        const { perPage, total } = response.data.data || {};
        this.pagination.itemsPerPage = perPage || 15;
        this.pagination.total = total;
        this.table.records = response.data.data.data;

        this.getProductsPartners();
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
        this.loading = false;
      });
    },
    
    async getProductsPartners() {
      const { data } = await shopkeeperAppApi.get(
        `/products/partners/get-all-id-products/${this.idShopkeeper}`);

      this.productsPartners = data.data;
    },
    
    saveOrUpdate(event) {
      const data = {
        "product_id" :  event.product_id,
        "selected_product_id" :  event.selected_product_id,
        "partner_user_id" : this.idPartner,
        "construp_user_id" : this.idShopkeeper,
        "tax_rate" : event.tax_rate,
        "cost_price": event.cost_price,
        "price_sales_format_1": event.price_sales_format_1
      }

      if(event.id) {
        data["id"] = event.id;
        this.updatePercentage(data);
      }else {
        this.linkProductPartner(data);
      }
    },

    async linkProductPartner(item){
      try {
        this.$store.dispatch('startLoader');
        const { data } = await shopkeeperAppApi.post(
          '/products/partners/sync', item);

        if(data.data){
          this.makeToast('sucesso', 'Produto vinculado com sucesso', 'success');
          this.get();
        };

        this.$store.dispatch('endLoader');
      } catch (error) {
        this.$store.dispatch('endLoader');
        this.makeToast('error', 'Erro ao vincular produto', 'danger');
      }
    },

    async updatePercentage(item) {
      try {
        this.$store.dispatch('startLoader');
        const { data } = await shopkeeperAppApi.put(
          '/products/partners/update-percentage', item );
        
        if(data.data){
          this.makeToast('sucesso', 'Porcentagem atualizada com sucesso', 'success');
          this.get();
        };
        
        this.$store.dispatch('endLoader');
      } catch (error) {
        this.$store.dispatch('endLoader');
        this.makeToast('error', 'Erro ao vincular produto', 'danger');
      }
    },
    
    async deleteProductPartner(idProduct) {
      const item = {
        "idShopkeeper": this.idShopkeeper,
        "idProduct": idProduct
      }

      try {
        this.$store.dispatch('startLoader');
        const { data } = await shopkeeperAppApi.post(
          `/products/partners/delete/${this.idPartner}`, item);
        
        if(data.data){
          this.makeToast('sucesso', 'Produto removido com sucesso', 'success');
          this.get();
        };
        
        this.$store.dispatch('endLoader');
      } catch (error) {
        this.$store.dispatch('endLoader');
        this.makeToast('error', 'Erro ao vincular produto', 'danger');
      }
    },
    linkFotos(origem) {
      if(origem == 'Belenus' || origem == 'fixadores') {
        return 'https://storage.googleapis.com/fotos-prd/';
      } else {
        return process.env.VUE_APP_FOTOS_URL;
      }
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    formatNumber(number) {
      return Intl.NumberFormat('pt-BR', {
        currency: 'BRL',
        style: 'currency',
      }).format(number);
    },
    closeModal(){
      this.open = !this.open;
      this.$emit('closeProductPartnerModal');
    },
    showPercentageModal(item, isUpdate = false) {
      let dataProduct = [];

      if(isUpdate) {
        dataProduct = this.productsPartners.find((product) => product.product_id == item.productId);
      }

      this.$refs.percentagePartnerModal.toggleOpen({
        product:item,
        partners: dataProduct
      });
    },
  },
};
</script>
